import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";

const menuItems = [
    {name: 'Alaptábla', url: '/controlling', icon: <SearchRoundedIcon/>, resource: 'generalLedgerAnalytics'},
    {name: 'Riportok', url: '/report', icon: <AssessmentRoundedIcon/>, resource: 'report'},
    {name: 'Kész riportok', url: '/finished-report', icon: <AssessmentRoundedIcon/>, resource: 'report'},
    {name: 'Ügyintézői jutalék', url: '/commission', icon: <PeopleRoundedIcon/>, resource: 'customUser'},
    {name: 'Mentett ügyintézői jutalék', url: '/saved-commissions', icon: <PeopleRoundedIcon/>, resource: 'savedCommission'},
    {name: 'Kontrolling', url: '/controlling-main', icon: <MonetizationOnRoundedIcon/>, resource: 'generalLedgerAnalytics'},
    {name: 'Ügyintézői eredményesség', url: '/employee-effectiveness', icon: <QueryStatsRoundedIcon/>, resource: 'customUser'},
    {name: 'Ügyfél eredményesség', url: '/select-view', icon: <BubbleChartRoundedIcon/>, resource: 'partner'},
    {name: 'Ügyfél forgalom', url: '/partner-traffic-effectiveness', icon: <BubbleChartRoundedIcon/>, resource: 'partner'},
]

export default menuItems